import { Empleado, CreateEmpleadoPayload, UpdateEmpleadoPayload } from '../tipos/vacaciones';
import { API_ENDPOINTS } from '../config/apiConfig';
import { fetchJson, postJson, putJson, deleteRequest } from './api';

/**
 * Obtiene todos los empleados.
 */
export function getAll(): Promise<Empleado[]> {
  return fetchJson<Empleado[]>(API_ENDPOINTS.empleados);
}

/**
 * Obtiene un empleado por su ID.
 */
export function getById(id: number): Promise<Empleado> {
  return fetchJson<Empleado>(`${API_ENDPOINTS.empleados}/${id}`);
}

/**
 * Crea un nuevo empleado.
 */
export function create(payload: CreateEmpleadoPayload): Promise<Empleado> {
  return postJson<Empleado>(API_ENDPOINTS.empleados, payload);
}

/**
 * Actualiza un empleado existente.
 */
export function update(id: number, payload: UpdateEmpleadoPayload): Promise<Empleado> {
  return putJson<Empleado>(`${API_ENDPOINTS.empleados}/${id}`, payload);
}

/**
 * Elimina (soft-delete) un empleado.
 */
export function remove(id: number): Promise<void> {
  return deleteRequest(`${API_ENDPOINTS.empleados}/${id}`);
}
